import { render, staticRenderFns } from "./LegalWaiverModal.vue?vue&type=template&id=14559f89&scoped=true&"
import script from "./LegalWaiverModal.vue?vue&type=script&lang=ts&"
export * from "./LegalWaiverModal.vue?vue&type=script&lang=ts&"
import style0 from "./LegalWaiverModal.vue?vue&type=style&index=0&id=14559f89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14559f89",
  null
  
)

export default component.exports